import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slice',
})
export class SlicePipe implements PipeTransform {
  transform(value: string, start: number, end: number): string {
    if (!value) return value;
    return value.slice(start, end);
  }
}
